import onSelectionChange from '../events/onSelectionChange';
import toggleSelectRowInternal from '../internal/toggleSelectRowInternal';
import * as mailListSelectionActions from 'owa-mail-actions';
import { orchestrator } from 'satcheljs';
import setFocusedRowKey from '../internal/mutators/setFocusedRowKey';
import setSelectionAnchorRowKey from '../internal/mutators/setSelectionAnchorRowKey';
import setMultiSelectionAnchorRowKey from '../internal/mutators/setMultiSelectionAnchorRowKey';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
/////////////////////////////////////// PLEASE READ ///////////////////////////////////////////////////////////
// This is a top level selection action, as such, it should never call other top-level selection
// actions in the same directory, but only call into internal subdirectories where the core logic is implemented.
// This prevents double logging for CTQs as well as prevents onSelectionChange from being fired multiple times
// for a single user action.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default orchestrator(mailListSelectionActions.toggleSelectRow, function (actionMessage) {
    var tableView = actionMessage.tableView;
    var isUserNavigation = actionMessage.isUserNavigation;
    var mailListItemSelectionSource = actionMessage.mailListItemSelectionSource;
    toggleSelectRowInternal(tableView, actionMessage.rowKey, isUserNavigation, mailListItemSelectionSource);
    if (isMailFeatureEnabled('tri-selectionRefactor')) {
        setMultiSelectionAnchorRowKey(tableView, null);
        setSelectionAnchorRowKey(tableView, actionMessage.rowKey);
        setFocusedRowKey(tableView, actionMessage.rowKey);
    }
    onSelectionChange(tableView, isUserNavigation, mailListItemSelectionSource);
});
//# sourceMappingURL=toggleSelectRowOrchestrator.js.map